import React, { useState, useContext, createRef } from 'react'
import styled from 'styled-components'
import Dropzone from 'react-dropzone'
import { SaveButton } from '../../inspect/components/edit-account/components/save-button'
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera'
import { AuthContext } from '../../../../../auth-context'
import { setProfilePicture } from '../../../../../api'
import { DashboardContext } from '../../../dashboard-context'
import emptyProfile from '../../../../../images/empty-profile.jpg'

const Container = styled.div`
  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 100%;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`

const Row = styled.div`
  display: flex;
  justify-content: center;
`

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`
const ProfileButton = styled.button`
  background: none;
  border: none;
  outline: none;
  transition: opacity 0.3s ease;
  img {
    border-radius: 200px;
    object-fit: cover;
    height: 150px;
    width: 150px;
    @media (max-width: 900px) {
      height: 100px;
      width: 100px;
    }
  }
  p {
    font-weight: 600;
    margin-top: 12px;
    text-transform: none;
  }
  &:hover {
    opacity: 0.8;
  }
`

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`

const ProfilePicture = (props) => {
  const { openSnackbar } = useContext(DashboardContext)
  const { user, updateUser } = useContext(AuthContext)
  const [selectedFile, updateSelectedFile] = useState(null)
  const [isLoading, updateIsLoading] = useState(false)
  const dropzoneRef = createRef();

  const handleDrop = (files) => {
    let newObject = null
    let newName = null
    files.forEach((file) => {
      if (file.type === 'image/jpg' || file.type === 'image/jpeg') {
        newObject = file
        newName = user.id + '.jpg'
      } else if (file.type === 'image/png') {
        newObject = file
        newName = user.id + '.png'
      }
    })
    if (newObject !== null) {
      if (selectedFile !== null) {
        URL.revokeObjectURL(selectedFile.preview)
      }
      updateSelectedFile({ object: newObject, name: newName, preview: URL.createObjectURL(newObject) })
    }
  }

  const clearSelectedFile = () => {
    if (selectedFile !== null) {
      URL.revokeObjectURL(selectedFile.preview)
      updateSelectedFile(null)
    }
  }

  const handleSubmit = () => {
    if (selectedFile !== null) {
      updateIsLoading(true)
      setProfilePicture(selectedFile.object, selectedFile.name, user.id).then(() => {
        setTimeout(() => {
          const newProfilePic = 'https://avn-resources-prod.s3.us-east-2.amazonaws.com/portal/' + user.id + '/' + selectedFile.name
          const newAvatarThumbUrl = 'https://avn-resources-prod-thumb.s3.us-east-2.amazonaws.com/portal/' + user.id + '/' + selectedFile.name
          updateUser(Object.assign({}, user, { profilePic: newProfilePic, avatar_thumb_url: newAvatarThumbUrl }))
          clearSelectedFile()
          updateIsLoading(false)
          openSnackbar('Profile picture updated', false)
        }, 1000)
      }).catch((err) => {
        clearSelectedFile()
        updateIsLoading(false)
        openSnackbar('Unable to update profile picture', true)
      })
    }
  }
  
  return (
    <React.Fragment>
      <Container className={props.className}>
        <Label>
          <PhotoCameraIcon /> Profile Picture
        </Label>
        <Row>
          <ProfileButton
            onClick={() => {
              dropzoneRef.current.open();
            }}
          >
            {selectedFile !== null ? (
              <img alt="profile-pic" src={selectedFile.preview} />
            ) : (
              <img
                alt="profile-pic"
                src={user.profilePic ? user.profilePic : emptyProfile}
              />
            )}
            <p>Change picture</p>
          </ProfileButton>
        </Row>
        <ButtonRow>
          <SaveButton
            disabled={selectedFile === null}
            isLoading={isLoading}
            onClick={handleSubmit}
          />
        </ButtonRow>
      </Container>
      <Dropzone style={{ display: 'none' }} ref={dropzoneRef} onDrop={handleDrop} accept={{ 'image/png': ['.png'], 'image/jpg': ['.jpg'], 'image/jpeg': ['.jpeg'] }}>
        {({getRootProps, getInputProps}) => (
          <div {...getRootProps()}>
            <input {...getInputProps()} />
          </div>
        )}
      </Dropzone>
    </React.Fragment>
  )
}

export default ProfilePicture